import { getCategoryDisplayLabel } from '@/utils/categoryTaxonomy';

function getRawArtworkMedium(candidate) {
  if (typeof candidate === 'string') {
    return candidate;
  }

  if (candidate && typeof candidate === 'object') {
    return candidate?.artwork_about?.artwork_medium ?? candidate?.artwork_medium ?? '';
  }

  return '';
}

export function getLocalizedArtworkMedium(candidate, locale) {
  const rawMedium = getRawArtworkMedium(candidate);
  return getCategoryDisplayLabel('medium', rawMedium, locale) || '-';
}
